<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useClaimStore, useNotificationStore } from '../../store';
import { CogIcon, ArrowTopRightOnSquareIcon, EnvelopeIcon } from '@heroicons/vue/24/solid';

import openBoxFolderForCurrentClaim, { openBoxSharedFolderForCurrentClaim } from "../../utils/open-box-folder";
import DotLegalStep from '../ui/badges/DotLegalStep.vue';
import { storeToRefs } from 'pinia';
import { computedAsync } from '@vueuse/core';
import adminAPI from '@/services/api';

async function generateNotificationDocument() {
  const loadingNotification = useNotificationStore().emitNotification({
    type: "wait",
    title: "Document en cours de génération (~30 sec à 1min)...",
  }, 90000);
  const claimId = useClaimStore().claim?.id;
  const response = await adminAPI.instance.post(
    `/admin/claims/${claimId}/documents/generate-notification-document`,
    null,
    { responseType: "blob" }
  );
  useNotificationStore().emitNotification({
    type: "success",
    title: "La Notification de cession a été ajoutée au dossier"
  })
  useClaimStore().retrieveClaim(useClaimStore().claim.id);
  loadingNotification.duration = 0;
  // downloadFileFromResponse(response);
}

const items = ref([
  {
    name: 'Générer la notification',
    description: `Notification de cession de créance à destination de la compagnie aérienne.`,
    iconColor: 'bg-yellow-500',
    cta: {
      text: 'Notification Cession',
      handleClick: generateNotificationDocument,
    },
    icon: CogIcon,
  },
  {
    name: 'Envoie du premier email',
    description: `Envoyer la première tentative de conciliation amiable à la compagnie.`,
    iconColor: 'bg-yellow-500',
    cta: {
      text: 'Générer le Brouillon',
      handleClick: async () => {
        const claim = useClaimStore().claim;
        const conversationId = claim.conversation?.frontConversationId
        if (!conversationId) {
          const waitNotif = useNotificationStore().emitNotification({
            title: "Initialisation en cours",
            message: "Temps d'attente estimé à 1 minute",  
            type: "wait",
          }, 30000);
          try {
            await adminAPI.initClaim(claim.id);
            useNotificationStore().emitNotification({ title: "Initialisation réussie" });
            await useClaimStore().refreshClaim();
            window.open(`https://app.frontapp.com/open/${useClaimStore().claim.conversation?.frontConversationId}`, "_blank")?.focus();
          } finally {
            waitNotif.duration = 0;
          }
        } else {
          window.open(`https://app.frontapp.com/open/${conversationId}`, "_blank")?.focus();
        }
      },
      tooltip: null
    },
    icon: EnvelopeIcon,
  },
]);
</script>
<template>
<div class="border-b bg-slate-50">
  <div class="max-w-lg py-5 mx-auto text-left">
    <div class="p-8 bg-white border rounded-md shadow">
      <h2 class="inline-flex text-base font-semibold leading-6 text-gray-900 align-middle">
        <!-- <div class="flex-none p-0.5 bg-red-400/30 rounded-full"><div class="h-1.5 w-1.5 rounded-full bg-red-500"></div></div> -->
        <div class="py-1 mr-2"><DotLegalStep :legal-step-name="useClaimStore().claim.claimLegalStep.name" /></div>
        Actions requises
      </h2>
      <p class="mt-1 text-sm text-gray-500">Quelques étapes sont nécessaires pour démarrer le dossier.</p>
      <ul role="list" class="mt-6 border-t border-b border-gray-200 divide-y divide-gray-200">
        <li v-for="(item, itemIdx) in items" :key="itemIdx">
          <div class="relative flex items-start py-4 space-x-6 pointer-events-auto group">
            <div v-if="false" class="flex-shrink-0">
              <span :class="[item.iconColor, 'inline-flex h-10 w-10 items-center justify-center rounded-lg']">
                <component :is="item.icon" class="w-6 h-6 text-white" aria-hidden="true" />
              </span>
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-sm font-medium text-gray-900">
                <p>
                  <!-- <span class="absolute inset-0" aria-hidden="true" /> -->
                  {{ itemIdx + 1 }}. {{ item.name }}
                </p>
              </div>
              <div class="text-sm text-gray-500">
                <p v-html="item.description" />
              </div>
            </div>
            <div class="self-center flex-shrink-0">
              <button type="button" v-tooltip="item.cta.tooltip"
                @click="() => item.cta.handleClick()"
                class="inline-flex cursor-pointer px-2 items-center gap-x-1.5 py-1.5 text-sm font-semibold text-gray-700 bg-white rounded shadow-sm group-hover:text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                <component :is="item.icon" class="w-4 h-4 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                {{ item.cta.text }}
              </button>
              
              <!-- <ChevronRightIcon class="w-5 h-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" /> -->
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>